import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
import {isObjectOrArray} from "../libraries/utils";

const clientTraceId = appConfig.clientTraceId();



/**
 * Nikola: 2019-12-19
 * If obj is a primitive like a string, number, undefined etc. it will be converted to an object
 * with one field called primitiveValue.
 * We do this to avoid this surprising feature of Javascript:
 * JSON.stringify(Object.assign("error object thrown as string", {extraMetadata:value})) -> "error object thrown as string"
 * In other words, if the error object thrown is a pure string, then the error handling code below messes up
 * because it tries to enrich the error object with additional attributes. But because of the above fact,
 * sending the enriched error object to the /api/clientlogging API will result in sending http body being a pure string
 * which breaks the server side part of this logging.
 * @param obj
 * @returns {*}
 */
function guaranteeJson(obj) {
	return isObjectOrArray(obj) ? obj : {primitiveValue: obj + ""};
}

export default {
	async postErrorToServer(_err) {

		const err = guaranteeJson(_err);
		try {
			// we need a possibility to skip logging in some cases
			// added flag to control the flow
			if(_err.skipLogging) {
				return;
			}
			//If it is a true error object then keys are invisible
			const myobj = {};
			Object.getOwnPropertyNames(err).forEach(k => {
				if (k !== "stack") myobj[k] = err[k];
			});
			const result = Object.assign(err, {
				href: window.location.href,
				errorObject: myobj
			});
			if (!result.errorObject.traceId) {
				result.errorObject.traceId = "ERR-" + clientTraceId;
			}
			if (err.stack) {
				Object.assign(result, {"STACKTRACE": err.stack});
			}
			try {
				console.log(result); // eslint-disable-line no-console
			} catch(_otherError) {
				//Circular json error
				console.log(_err); // eslint-disable-line no-console
			}
			let result2;
			try {
				if (isObjectOrArray(result)) {
					result2 = result;
				} else {
					// Should never happen but we are paranoid about error handling
					result2 = { primitiveValue: result + ""};
				}
			} catch(err) {
				result2 = {};
				// Brute force avoid circular json
				// Very unlikely, but again we are paranoid
				Object.keys(result).forEach(key => {
					result2[key] = "" + result[key];
				});
			}
			return BifrostBackendNestApi.post("/logger/_clientlogging", result2).catch(err => {
				console.log("Error while sending log to server."); // eslint-disable-line no-console
				console.log(err); // eslint-disable-line no-console
			});

		} catch(err) {
			console.log(err); // eslint-disable-line no-console
		}
	},
	// eventDomain=SunsetKiosk&eventName=Main&message=App%20(re)started&eventCategory=SunsetKiosk
	async postEvent({
		eventDomain = "BifrostShop",
		eventName = "CustomLog",
		message,
		eventCategory = "BifrostShop",
		payload
	}) {
		return BifrostBackendNestApi.post("/logger" +
			`?eventDomain=${encodeURIComponent(eventDomain)}&eventName=${encodeURIComponent(eventName)}&message=${encodeURIComponent(message)}&eventCategory=${encodeURIComponent(eventCategory)}`, payload).catch(err => {
			console.log("Error while sending log to server."); // eslint-disable-line no-console
			console.log(err); // eslint-disable-line no-console
		});
	}
};
